// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__3OeRE","content":"Checkbox_content__g_lIG"};